import TokenCard from './token-card/token-card';
import { TokenType } from 'types';

import FungibleTokens from 'services/fungible-tokens';
import { useFungibleTokensIncludingNEAR } from 'lib/hooks/use-fungible-tokens-including-near';
const { getUniqueTokenIdentity } = FungibleTokens;

import { StyledCardsWrapper } from './cards.style';

const TokenCards = () => {
  const fungibleTokensList = useFungibleTokensIncludingNEAR();
  if (fungibleTokensList.length !== 4) return null;
  return (
    <StyledCardsWrapper columns={3}>
      {fungibleTokensList.map((token: TokenType) => (
        <TokenCard key={getUniqueTokenIdentity(token)} token={token} />
      ))}
    </StyledCardsWrapper>
  );
};

export default TokenCards;
